import { render, staticRenderFns } from "./PaymentMain.vue?vue&type=template&id=06a66448&scoped=true"
import script from "./PaymentMain.vue?vue&type=script&lang=ts"
export * from "./PaymentMain.vue?vue&type=script&lang=ts"
import style0 from "./PaymentMain.vue?vue&type=style&index=0&id=06a66448&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a66448",
  null
  
)

export default component.exports